import { gql } from '@apollo/client';
import { apolloBatchClient } from './Apollo';

const GET_TRANSLATION = gql`
  query Translations($components: [String]) {
    translations(components: $components) {
      id
      component
      translations {
        id
        slug
        translation
      }
    }
  }
`;

type TranslationItem = {
  id: string;
  component: string;
  translations: {
    id: string;
    slug: string;
    translation: string;
  }[];
};

export const translate = async (
  component: string,
  keyword: string,
): Promise<string> => {
  const { data } = await apolloBatchClient.query<
    { translations: TranslationItem[] },
    { components: string[] }
  >({
    query: GET_TRANSLATION,
    variables: { components: [component] },
  });

  const componentTranslations = data.translations.find(
    (t) => t.component === component,
  );

  // Probably no translations for requested component, or request failed
  if (!componentTranslations?.translations) {
    return '';
  }

  const requestedTranslation = componentTranslations.translations.find(
    (t) => t.slug === keyword,
  );

  // No translation for requested keyword
  if (!requestedTranslation) {
    return '';
  }

  return requestedTranslation.translation;
};
